import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { saveAs } from "file-saver";
import { CourseUnitsService } from 'src/app/services/course-units.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/*Import services */
import { AttendanceService } from '../services/attendance.service';
import { DownloadService } from '../../app/services/download.service'
/*Import component*/
import { ChangeStatusComponent } from './change-status/change-status.component';
import * as moment from 'moment';
import { LearnerService } from '../services/learner.service';
import { UtilityService } from '../services/utility.service';
import { AllotmentConfirmationComponent } from '../courses/assignment-status/allotment-confirmation/allotment-confirmation.component';
// require('buffer').Buffer;
@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {

  @Input('job') job
  @ViewChild('register', { static: false }) register: ElementRef;
  @Output() learnerObj: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateLogs: EventEmitter<any> = new EventEmitter<any>();
  @Output() finalArray: EventEmitter<any> = new EventEmitter<any>();
  attendance: any;
  attendanceCopy: any;
  currentUser: any;
  user: any;
  statusToChange: any;
  learnersToChange: any;
  clearData: boolean = false;
  isPdfDownload: boolean = false;
  selectedLearners: any = [];
  data2: any = [];
  dataForCsv = []
  setTimeChanges
  loading: boolean = false;
  unitList
  noDataMessage: any;
  logToUpdate: any = [];
  hoverIndex: any;
  pdfDownload: any;
  totalCounts: any = [1];
  attendanceZero: any;
  attendanceOne: any;
  currentJob
  jobId

  noDataMsgTrainer = {
    title: "No Learners!",
    data: "You have not yet added any learners"
  }
  courseMetaId: any;
  courseId: any;
  isAdmin: boolean = false
  private learnerRemove: Subject<any> = new Subject<any>();
  private addLearnerSubscription: Subject<any> = new Subject<any>();
  noDataMsgCandidate = {
    title: "No Candidates!",
    data: "You have not yet added any candidates"
  }
  displayLegends: boolean = false
  selectedTab = 1;

  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _change: ChangeDetectorRef,
    public _attendanceService: AttendanceService,
    public _downloadDownload: DownloadService,
    public _courseUnitsService: CourseUnitsService,
    public _utilityServices: UtilityService,
    private _learnerService: LearnerService,
  ) {
    this._courseUnitsService.unitListObservable().subscribe((unitList) => {
      // console.log("unit list in model");
      this.unitList = unitList
      // console.log("unit list in model =====> ", this.unitList);
    })

    this._learnerService.newLearnerObservable()
      .pipe(
        takeUntil(this.addLearnerSubscription)
      )
      .subscribe((newLearner) => {
        this._change.detectChanges();
        console.log("who is new learner", newLearner);
        console.log("current job value when new learner added", this.job);
        console.log("what is the final array to be store", this.attendance);
        newLearner.learner['checked'] = false
        if (this.job && this.job.jobType != 'mp') {
          const getAttendanceParams = {
            jobId: this.job._id
          }
          this.getAttendance(getAttendanceParams);
        }
        console.log("finall attedence data here ==>", this.attendance)
      });


    this._learnerService.removeLearnerObservable()
      .pipe(
        takeUntil(this.learnerRemove)
      )
      .subscribe((learner) => {
        console.log("when learner remove from job", learner);
        let index = this.attendance.findIndex(x => x._id === learner._id);
        if (index > -1) {
          this.attendance.splice(index, 1)
          console.log("after learner remove in assignment page", this.attendance);
        }
      })
  }



  ngOnInit() {
    console.log(this.job);
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.user.isAdmin) this.isAdmin = true
    console.groupEnd();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.job && changes.job.currentValue) {
      // const currentValue: any = changes.job.currentValue
      let objLength = Object.keys(changes.job.currentValue).length
      console.log("Changes in job", changes.job, objLength);
      if (objLength != 0) {
        this.job = changes.job.currentValue;
        this.jobId = this.job._id
        this.courseMetaId = this.job.course.courseMetaId._id
        this.courseId = this.job.course._id

        if (this.job && this.job.jobType != 'mp') {
          const getAttendanceParams = {
            jobId: this.job._id
          }
          this.getAttendance(getAttendanceParams);
        }
        else {
          const getAttendanceMpJobParams = {
            jobId: this.job._id,
          }
          if (this.job && this.job.linkedJob && this.job.linkedJob._id) {
            getAttendanceMpJobParams['linkedJob'] = this.job.linkedJob._id
          }
          this.getAttendanceMpJob(getAttendanceMpJobParams)
        }

      }
    }
  }

  ngOnDestroy() {
    console.log("HELLO HERE IS ON DESTROY", this.learnerRemove.closed)
    this.learnerRemove.next();
    this.learnerRemove.complete();
    this.addLearnerSubscription.next();
    this.addLearnerSubscription.complete();

    console.log("this.learnerRemove!!!", (!this.learnerRemove.closed))
  }

  // Utility Functions

  changeStatus() {
    this._utilityServices.commonDialogBoxOpen(ChangeStatusComponent)
      .afterClosed().subscribe((status) => {
        console.log("Status ===>", status);
        if (status) {
          this.statusToChange = status.status;
          this.setTimeChanges = status.time
          console.log("HERE IS THE TIME", this.setTimeChanges)
          this.clearData = false;
          this.changeStatusOfLearner()
          return this._utilityServices.handleSnackBar({ msg: "Attendance marked successfully!", button: "Ok" })
        }
      }, (err) => {
        return this._utilityServices.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      });
  }

  changeStatusOfLearner() {

    this.loading = true;
    console.group("changeStatusOfLearner", this.learnersToChange);
    console.log("this. staus to change", this.statusToChange);
    _.forEach(this.learnersToChange, (singleLearner) => {

      _.forEach(singleLearner.attendance, (singleAttendanceLog) => {
        if (singleAttendanceLog['pmStatus']) singleAttendanceLog['pmStatus'] = this.statusToChange, singleAttendanceLog['attendancePmHours'] = this.setTimeChanges;
        if (singleAttendanceLog['amStatus']) singleAttendanceLog['amStatus'] = this.statusToChange, singleAttendanceLog['attendanceAmHours'] = this.setTimeChanges;
        console.log("Learner to changes in attendance==>", singleAttendanceLog)

      })

    });
    if (this.learnersToChange && this.learnersToChange.length) this.updateAttendance();

  }

  learnerForStatus(event) {
    console.log("event when learner is marked", event);
    this.learnersToChange = event;
    console.log("after the marked", this.learnersToChange);
    this._change.detectChanges()
  }

  changesStatus(event) {
    console.log("event when learner is marked", event);
    this.attendance = event
  }

  learnerIndex(i) {
    this.hoverIndex = i;
  }

  learnerIndexChanged(i) {
    this.hoverIndex = -1
  }

  updateDate(event) {
    console.log("event in attendance-row = ", event);
    this.attendance = event
    console.log("this.attendance in attendance-row = ", this.attendance);
  }

  updateLog(event) {                     // select/de-select checkbox
    console.log("event get in updateLog------------------>", event);

    if (event.log.isSelected)
      this.learnersToChange = this.logToUpdate;
    switch (event.log.isSelected) {
      case true:
        this.addDatatoUpdateLogArray(event.log)
        break;

      case false:
        this.removeDataFromUpdateLogArray(event.log)
        break;

      default:
        break;
    }
  }

  addDatatoUpdateLogArray(log) {
    console.group("addDatatoUpdateLogArray", log);
    console.log("this is another", this.logToUpdate);

    const recordIndex = _.findLastIndex(this.logToUpdate, (o) => { return o.learnerId == log.learnerId; })
    if (recordIndex != -1) {
      const attendanceIndex = _.findLastIndex(this.logToUpdate[recordIndex].attendance, (o) => { return o.singleJobDateId == log.attendance.singleJobDateId; });

      if (attendanceIndex != -1) this.logToUpdate[recordIndex].attendance[attendanceIndex][log.status] = log.attendance[log.status];
      else this.logToUpdate[recordIndex].attendance.push(log.attendance);
      this.learnersToChange = this.logToUpdate;
    }
    else {
      const obj = {
        learnerId: log.learnerId,
        attendance: [
          log.attendance
        ]
      }
      this.logToUpdate.push(obj);
      this.learnersToChange = this.logToUpdate;
    }

    console.log("this.logToUpdate record When added ==>", this.logToUpdate)
    console.groupEnd();
  }

  removeDataFromUpdateLogArray(log) {
    const recordIndex = _.findLastIndex(this.logToUpdate, (o) => { return o.learnerId == log.learnerId; })
    const attendanceIndex = _.findLastIndex(this.logToUpdate[recordIndex].attendance, (o) => { return o.day == log.attendance.day; });
    delete this.logToUpdate[recordIndex].attendance[attendanceIndex][log.status]

    if (!this.logToUpdate[recordIndex].attendance[attendanceIndex]["amStatus"] && !this.logToUpdate[recordIndex].attendance[attendanceIndex]["pmStatus"])
      this.logToUpdate[recordIndex].attendance.splice(attendanceIndex, 1);

    if (!this.logToUpdate[recordIndex].attendance.length) {
      this.logToUpdate.splice(recordIndex, 1);
    }
    this.learnersToChange = this.logToUpdate;
  }

  filter() {                                                // filter learner attendance
    this.selectedLearners.length ? this.attendance = JSON.parse(JSON.stringify(this.selectedLearners)) : this.attendance = this.attendanceCopy;
    console.log(this.selectedLearners, this.attendance);
    _.forEach(this.learnersToChange, (singleLearner, index) => {
      const recordIndex = _.findIndex(this.attendance, (o) => { return o._id == singleLearner.learnerId; })
      if (recordIndex != -1) {

        _.forEach(singleLearner.attendance, (singleAttendance) => {
          const attendanceIndex = _.findIndex(this.attendance[recordIndex].attendance, (o) => { return o.day == singleAttendance.day; });
          console.log(singleAttendance);
          if (singleAttendance.amStatus) {
            this.attendance[recordIndex].attendance[attendanceIndex]["amIsSelected"] = true;
          }
          if (singleAttendance.pmStatus) {
            this.attendance[recordIndex].attendance[attendanceIndex]["pmIsSelected"] = true;
          }

        });
      }
    });
  }

  addMoreDay() {                                           // add new day
    console.log("plus btn clicked")
    let data = {
      courseMetaId: this.courseMetaId,
      courseId: this.courseId,
      jobDatesList: this.attendance[0].jobDatesList.jobDatesList,
      register: true,
      scheduleDates: this.job.scheduleDates,
      jobId: this.jobId,
      unitList: false,
      isAdd: true
    }
    console.log("data pass in model", data);
    this._utilityServices.commonDialogBoxOpen(AllotmentConfirmationComponent, data)
      .afterClosed().subscribe(res => {
        console.log("updated data get", res);
        if (res == undefined) return
        else {
          let tempDate = res.attendance[0].attendance.findIndex((x) => x.date == res.date)
          if (tempDate != -1) {
            res.attendance[0].attendance[tempDate]['newDay'] = true
          }
          this.attendance = res.attendance
          this.finalArray.emit(this.attendance);
          console.log("Check existing data of dates add", this.attendance);
          this._utilityServices.handleSnackBar({ msg: "Day added successfully!", button: "Ok" })
          this._change.detectChanges()
        }
      }, (error) => {
        console.log('edit time some error occure!!', error)
        this._utilityServices.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
      })
  }


  // API calls

  getAttendance(params) {
    this.loading = true

    this._attendanceService.getAttendance(params)
      .subscribe((res: any) => {
        console.log("response in attendence component---->", res)
        if (typeof res.data != 'string') {
          this.attendance = res.data;
          this.finalArray.emit(this.attendance);
          this.attendanceCopy = JSON.parse(JSON.stringify(res.data));

          if (this.attendance && this.attendance.length) {
            let attedenceCopy = this.attendance.sort()
            console.log("call this first if", this.attendance.length);
            console.log("getAttendance() ---> this.attendance : ", this.attendance);
            this.displayLegends = true
          }

          if (this.attendance[0] && this.attendance[0].attenadance && !this.attendance[0].attenadance.length) {
            console.log("this is else part", this.attendance);

            this.noDataMessage = { title: 'No Course Duration', data: "You have not yet addded course duration" };
            this.displayLegends = false
          }
        }
        else {
          this.attendance = []
        }
        this.loading = false
      }, (err) => {
      });
  }

  /*For mp Jobs*/

  getAttendanceMpJob(getAttendanceMpJobParams) {
    this.loading = true
    this._attendanceService.getAttendanceMpJob(getAttendanceMpJobParams)
      .subscribe((res: any) => {
        console.log("response of mp jobs", res);
        if (typeof res.data != 'string') {
          this.attendance = res.data;
          this.attendanceCopy = JSON.parse(JSON.stringify(res.data));
        }
        if (this.attendance && this.attendance.length) {
          this.displayLegends = true
        }
        this.loading = false
      }, (err) => {
      });
  }

  updateAttendance() {
    const objToSend = {
      jobId: this.job._id,
      learners: this.learnersToChange
    }
    console.log("this is the object which is send to server", objToSend);
    this._attendanceService.updateAttendance(objToSend).subscribe((res: any) => {
      if (res == undefined) return
      else {
        this.attendance = res.data
        this.logToUpdate = []
        this.learnersToChange = []
      }
      this.loading = false
    }, (err) => {
      console.log("error ==>", err);
    });
    console.groupEnd();
  }

  Download(jobName) {                      // download csv
    this._change.detectChanges()
    this._change.detectChanges()
    console.log("attendance data when click on download", this.job);
    console.log("this.attendance while click on download1", this.attendance);
    this.loading = true
    let data = {
      unitList: this.unitList,
      attendance: this.attendance,
      job: this.job,
      csvType: 'attedance'
    }
    this._downloadDownload.downloadCSV(data).subscribe((csvResponse) => {
      this.loading = false
      console.log("hello csv reponse ..", csvResponse)
      const downloadLink = document.createElement("a");
      // let temp = res.zip.title.replace(/\s+/g, '_');

      if (csvResponse && csvResponse.data) {
        downloadLink.href = csvResponse.data;
        this._utilityServices.handleSnackBar({ msg: "CSV download Successfully!", button: "Ok" })
        let title = jobName ? jobName + "Register" : 'Register'
        downloadLink.download = title;
        downloadLink.click();
      }
    }, (error) => {
      this.loading = false
      this._utilityServices.handleSnackBar({ msg: "CSV download Fail!", button: "Ok" })

      console.log("SOME error occure ===>", error)
    })
  }
  updatedAttendence(event) {
    console.log("event.........1", event.attendence);
    this.attendance = event.attendence
  }

}
